import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Digital from '../views/Digital.vue'
import Other from '../views/Other.vue'
import Contact from '../views/Contact.vue'
import Hyatt from '../views/projects/Hyatt.vue'
import Erbium from '../views/projects/Erbium.vue'
import Cadex from '../views/projects/Cadex.vue'
import W2W from '../views/projects/W2W.vue'
import Epicure from '../views/projects/Epicure.vue'
import MoreProjects from '../views/projects/More.vue'
import Painting from '../views/projects/Painting.vue'
import Architecture from '../views/projects/Architecture.vue'
import Mediums from '../views/projects/Mediums.vue'
import Game from '../views/projects/Game.vue'
import Recent from '../views/projects/Recent.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/digital',
    name: 'Digital',
    component: Digital
  },
  {
    path: '/other',
    name: 'Other',
    component: Other
  },
  {
    path: '/other/painting',
    name: 'Painting',
    component: Painting
  },
  {
    path: '/other/mediums',
    name: 'Mediums',
    component: Mediums
  },
  {
    path: '/other/architecture',
    name: 'Architecture',
    component: Architecture
  },
  {
    path: '/other/game',
    name: 'Game',
    component: Game
  },
  {
    path: '/digital/recent',
    name: 'Recent',
    component: Recent
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/digital/hyatt',
    name: 'Hyatt',
    component: Hyatt
  },
  {
    path: '/digital/erbium',
    name: 'Erbium',
    component: Erbium
  },
  {
    path: '/digital/cadex',
    name: 'Cadex',
    component: Cadex
  },
  {
    path: '/digital/w2w',
    name: 'W2W',
    component: W2W
  },
  {
    path: '/digital/epicure',
    name: 'Epicure',
    component: Epicure
  },
  {
    path: '/digital/more-projects',
    name: 'MoreProjects',
    component: MoreProjects
  },
  {
    path: '/*',
    name: 'NotFound',
    component: NotFound
  },
]


const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  }
})

export default router
